import { DateTime } from 'luxon'
import { SchedulingMonth } from './types'

export const TODAY = DateTime.now()

export const schedulingMonths = (): SchedulingMonth[] => {
  return [
    {
      label: `${TODAY.toFormat('LLLL')} de ${TODAY.toFormat('y')}`,
      value: TODAY.toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 1 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 1,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 1 }).toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 2 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 2,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 2 }).toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 3 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 3,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 3 }).toFormat('D'),
    },
  ]
}
export const SEX_OPTIONS = [
  {
    id: '1',
    key: '1',
    label: 'Masculino',
    value: '1',
  },
  {
    id: '2',
    key: '2',
    label: 'Feminino',
    value: '2',
  },
  {
    id: '3',
    key: '3',
    label: 'Outros',
    value: '3',
  },
]
export const RELATIONSHIP_OPTIONS = [
  {
    id: '1',
    key: '1',
    label: 'Pai/Mãe',
    value: 'PAI_MAE',
  },
  {
    id: '2',
    key: '2',
    label: 'Cônjuge',
    value: 'CONJUGE',
  },
  {
    id: '3',
    key: '3',
    label: 'Irmão',
    value: 'IRMAO',
  },
  {
    id: '4',
    key: '4',
    label: 'Filho',
    value: 'FILHO',
  },
  {
    id: '5',
    key: '5',
    label: 'Tio',
    value: 'TIO',
  },
  {
    id: '6',
    key: '6',
    label: 'Amigo',
    value: 'AMIGO',
  },
  {
    id: '7',
    key: '7',
    label: 'Outros',
    value: 'OUTROS',
  },
]

export const PREGNANCY_DAYS_OPTIONS = Array?.from({ length: 6 })?.map(
  (_, index) => {
    const day = index + 1
    return {
      label: `${day} dia${day !== 1 ? 's' : ''}`,
      value: `${day}`,
    }
  },
)

export const PREGNANCY_WEEKS_OPTIONS = Array?.from({ length: 42 })?.map(
  (_, index) => {
    const week = index + 1
    return {
      label: `${week} semana${week !== 1 ? 's' : ''}`,
      value: `${week}`,
    }
  },
)

export const IMMEDIATE_ATTENDANCE = 'immediate'
export const SCHEDULED_ATTENDANCE = 'scheduled'
export const SCHEDULED_ATTENDANCE_W_PREFERENCE = 'scheduled_w_preference'

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Campo obrigatório',
  INVALID_CHARACTERS_AND_SPACES: 'Remova os espaços ou caracteres especiais',
}

export const ATTENDANCE_TYPES = {
  immediate: 'IMEDIATO',
  scheduled: 'AGENDADO',
  scheduled_w_preference: 'AGENDADO_SEM_PREFERENCIA',
}
